import React from 'react'
import {FaCreativeCommonsZero} from 'react-icons/fa'

function Empty({objectName}) {
    return (
        <div className='flex gap-3 py-4 border rounded-xl border-slate mt-3 px-4 '>
            <FaCreativeCommonsZero className='h-7 w-7 text-info'/>
            <p>No {objectName} found yet!</p>
        </div>
    )
}

export default Empty